module.exports = __webpack_public_path__ + "site/img/team_slogan_1x2.3ab8fb5a.jpg";